import { Box } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router';
import { useMenus, getMenuIcon } from '../../config/menus.tsx';
import request from '../../config/request.ts';
import Logo from '../../assets/crescent-logo.png';
import '../../styles/scss/Sidebar.scss';

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { menus, refresh: refreshMenus } = useMenus();

  const isActive = (path: string) =>
    location.pathname === path || location.pathname.startsWith(path + '/');

  const handleLogout = async () => {
    try {
      await request.post('/logout');
    } catch {
      // ignore network errors on logout
    } finally {
      localStorage.removeItem('accessToken');
      await refreshMenus();
      navigate('/');
    }
  };

  return (
    <Box component="aside" className="sidebar">
      <Box className="sidebar-header">
        <Box className="sidebar-logo">
          {/* <img src={Logo} alt="Marvel Mattress" /> */}
        </Box>
      </Box>

      <nav className="sidebar-nav">
        <Box className="nav-section">
          {menus.map((menu) => {
            const to = `/admin${menu.route}`;
            return (
              <Link
                key={menu.id}
                to={to}
                className={`nav-item ${isActive(to) ? 'active' : ''}`}
              >
                {getMenuIcon(menu.icon)}
                <span className="nav-text">{menu.menu_name}</span>
              </Link>
            );
          })}
        </Box>
      </nav>

      <Box className="sidebar-footer">
        <Box className="sidebar-links">
          <button type="button" onClick={handleLogout} className="logout">
            <span className="logout-icon">
              <span className="material-symbols-outlined">logout</span>
            </span>
            <span className="logout-text">Sign Out</span>
            <span className="material-symbols-outlined logout-arrow">
              arrow_forward
            </span>
          </button>
        </Box>
      </Box>
    </Box>
  );
}